import { ConfirmationModal, useModal } from '@procurify/ui'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { useMutateLockCardAdmin } from '@webapp/modules/spending-cards/features/lock-card-admin/models/useMutateLockCardAdmin'
import messages from './messages'

export const useLockCardAdminPresenter = () => {
  const modal = useModal()
  const intl = useProcurifyIntl()

  const { lock } = useMutateLockCardAdmin()

  const showLockCardModal = async (
    externalId: string,
    onCardLocked: () => void = () => null
  ) => {
    await modal.showModal(ConfirmationModal, {
      open: true,
      icon: 'attention',
      type: 'warning',
      header: intl.formatMessage(messages.modalTitle),
      content: intl.formatMessage(messages.modalContent),
      confirmButtonText: intl.formatMessage(messages.modalConfirmButton),
      handleDismiss: () => modal.hideModal(),
      onConfirm: async () => {
        try {
          await lock({ externalId })

          toast.success({
            title: intl.formatMessage(messages.successToastMessage),
          })
          onCardLocked()
          modal.hideModal()
        } catch (error) {
          toast.error({
            title: intl.formatMessage(messages.errorToastMessage),
          })
        }
      },
    })
  }

  return {
    commands: {
      showLockCardModal,
    },
  }
}
